import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TokenService } from '../service/token.service';

export const authGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const hasTokens = tokenService.hasTokens();
  const isAuthRoute = state.url.includes('/auth/');
  const isLogoutRoute = state.url.includes('/auth/logout');

  if (isAuthRoute && hasTokens && !isLogoutRoute) {
    return router.parseUrl('/dashboard');
  }

  if (!isAuthRoute && !hasTokens) {
    return router.parseUrl('/auth/sign-in');
  }

  return true;
};


